import React, { useState } from 'react';
import styles from './AddProject.module.css';

const AddProject = ({ onSave, onCancel }) => {
    const [projectName, setProjectName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!projectName.trim()) {
            setError('Project name is required');
            return;
        }

        if (projectName.trim().length < 2) {
            setError('Project name must be at least 2 characters long');
            return;
        }

        setLoading(true);
        setError('');

        try {
            await onSave({ name: projectName.trim() });
        } catch (err) {
            setError(err.message || 'Failed to create project');
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setProjectName('');
        setError('');
        onCancel();
    };

    return (
        <div className={styles.addProjectContainer}>
            <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.formGroup}>
                    <label htmlFor="projectName" className={styles.label}>
                        Project Name
                    </label>
                    <input
                        type="text"
                        id="projectName"
                        value={projectName}
                        onChange={(e) => setProjectName(e.target.value)}
                        className={styles.input}
                        placeholder="Enter project name"
                        disabled={loading}
                    />
                    {error && <span className={styles.errorText}>{error}</span>}
                </div>

                <div className={styles.formActions}>
                    <button
                        type="button"
                        onClick={handleCancel}
                        className={styles.cancelButton}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className={styles.saveButton}
                        disabled={loading || !projectName.trim() || projectName.trim().length < 2}
                    >
                        {loading ? 'Creating...' : 'Create Project'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddProject; 